var map = {
	"./+accion/formato.accion.module": [
		"./src/app/+formato/+accion/formato.accion.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"accion-formato-accion-module"
	],
	"./actions/lenguas.actions.module": [
		"./src/app/+admin/catalogos/lenguas/actions/lenguas.actions.module.ts",
		"common",
		"actions-lenguas-actions-module"
	],
	"app/+admin/+autorizacion/autorizacion-actions/actions.module": [
		"./src/app/+admin/+autorizacion/autorizacion-actions/actions.module.ts",
		"common",
		"app-admin-autorizacion-autorizacion-actions-actions-module"
	],
	"app/+admin/+autorizacion/autorizacion.module": [
		"./src/app/+admin/+autorizacion/autorizacion.module.ts",
		"default~app-admin-autorizacion-autorizacion-module~app-admin-est-consultas-est-consultas-module~app-~2a3300ba",
		"common",
		"app-admin-autorizacion-autorizacion-module"
	],
	"app/+admin/+groups/groups.module": [
		"./src/app/+admin/+groups/groups.module.ts",
		"common",
		"app-admin-groups-groups-module"
	],
	"app/+admin/+groups/grupo-actions/actions.module": [
		"./src/app/+admin/+groups/grupo-actions/actions.module.ts",
		"common",
		"app-admin-groups-grupo-actions-actions-module"
	],
	"app/+admin/+jerarquias/jerarquias.module": [
		"./src/app/+admin/+jerarquias/jerarquias.module.ts",
		"default~app-admin-autorizacion-autorizacion-module~app-admin-est-consultas-est-consultas-module~app-~2a3300ba",
		"common",
		"app-admin-jerarquias-jerarquias-module"
	],
	"app/+admin/+modules/+actions/modules-actions.module": [
		"./src/app/+admin/+modules/+actions/modules-actions.module.ts",
		"default~app-admin-catalogos-lenguas-lenguas-module~app-admin-modules-actions-modules-actions-module~~8af19d05",
		"common",
		"app-admin-modules-actions-modules-actions-module"
	],
	"app/+admin/+modules/modules.module": [
		"./src/app/+admin/+modules/modules.module.ts",
		"default~app-admin-autorizacion-autorizacion-module~app-admin-est-consultas-est-consultas-module~app-~2a3300ba",
		"common",
		"app-admin-modules-modules-module"
	],
	"app/+admin/+profiles/+actions/profiles-actions.module": [
		"./src/app/+admin/+profiles/+actions/profiles-actions.module.ts",
		"default~app-admin-catalogos-lenguas-lenguas-module~app-admin-modules-actions-modules-actions-module~~8af19d05",
		"common",
		"app-admin-profiles-actions-profiles-actions-module"
	],
	"app/+admin/+profiles/profiles.module": [
		"./src/app/+admin/+profiles/profiles.module.ts",
		"default~app-admin-autorizacion-autorizacion-module~app-admin-est-consultas-est-consultas-module~app-~2a3300ba",
		"common",
		"app-admin-profiles-profiles-module"
	],
	"app/+admin/+users/+actions/users-actions.module": [
		"./src/app/+admin/+users/+actions/users-actions.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"default~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-catalogos-cie9-cie9-module~ap~5ed01e92",
		"default~app-admin-catalogos-lenguas-lenguas-module~app-admin-modules-actions-modules-actions-module~~8af19d05",
		"default~app-admin-users-actions-users-actions-module~app-turnosLaborales-turnos-module",
		"common",
		"app-admin-users-actions-users-actions-module"
	],
	"app/+admin/+users/users.module": [
		"./src/app/+admin/+users/users.module.ts",
		"default~app-admin-autorizacion-autorizacion-module~app-admin-est-consultas-est-consultas-module~app-~2a3300ba",
		"common",
		"app-admin-users-users-module"
	],
	"app/+admin/admin.module": [
		"./src/app/+admin/admin.module.ts",
		"app-admin-admin-module"
	],
	"app/+admin/catalogos/catpreguntas/catpreguntas.module": [
		"./src/app/+admin/catalogos/catpreguntas/catpreguntas.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-catalogos-cie9-cie9-module~ap~5ed01e92",
		"common",
		"app-admin-catalogos-catpreguntas-catpreguntas-module"
	],
	"app/+admin/catalogos/cie10/cie10.module": [
		"./src/app/+admin/catalogos/cie10/cie10.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"app-admin-catalogos-cie10-cie10-module"
	],
	"app/+admin/catalogos/cie9/cie9.module": [
		"./src/app/+admin/catalogos/cie9/cie9.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-catalogos-cie9-cie9-module~ap~5ed01e92",
		"common",
		"app-admin-catalogos-cie9-cie9-module"
	],
	"app/+admin/catalogos/cuestionario/catcuestionario.module": [
		"./src/app/+admin/catalogos/cuestionario/catcuestionario.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-catalogos-cie9-cie9-module~ap~5ed01e92",
		"common",
		"app-admin-catalogos-cuestionario-catcuestionario-module"
	],
	"app/+admin/catalogos/discapacidades/discapacidades.module": [
		"./src/app/+admin/catalogos/discapacidades/discapacidades.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"app-admin-catalogos-discapacidades-discapacidades-module"
	],
	"app/+admin/catalogos/especialidades/especialidades.module": [
		"./src/app/+admin/catalogos/especialidades/especialidades.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-catalogos-cie9-cie9-module~ap~5ed01e92",
		"common",
		"app-admin-catalogos-especialidades-especialidades-module"
	],
	"app/+admin/catalogos/estudios/estudios.module": [
		"./src/app/+admin/catalogos/estudios/estudios.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"app-admin-catalogos-estudios-estudios-module"
	],
	"app/+admin/catalogos/formacion/formacion.module": [
		"./src/app/+admin/catalogos/formacion/formacion.module.ts",
		"app-admin-catalogos-formacion-formacion-module"
	],
	"app/+admin/catalogos/lenguas/actions/lenguas.actions.module": [
		"./src/app/+admin/catalogos/lenguas/actions/lenguas.actions.module.ts",
		"common",
		"actions-lenguas-actions-module"
	],
	"app/+admin/catalogos/lenguas/lenguas.module": [
		"./src/app/+admin/catalogos/lenguas/lenguas.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"default~app-admin-catalogos-lenguas-lenguas-module~app-admin-modules-actions-modules-actions-module~~8af19d05",
		"common",
		"app-admin-catalogos-lenguas-lenguas-module"
	],
	"app/+admin/catalogos/medicamentos/medicamentos.module": [
		"./src/app/+admin/catalogos/medicamentos/medicamentos.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"app-admin-catalogos-medicamentos-medicamentos-module"
	],
	"app/+admin/catalogos/motivos-envio/motivos-envio.module": [
		"./src/app/+admin/catalogos/motivos-envio/motivos-envio.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"app-admin-catalogos-motivos-envio-motivos-envio-module"
	],
	"app/+admin/catalogos/nacionalidades/nacionalidades.module": [
		"./src/app/+admin/catalogos/nacionalidades/nacionalidades.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"app-admin-catalogos-nacionalidades-nacionalidades-module"
	],
	"app/+admin/catalogos/region-sanitaria/region-sanitaria.module": [
		"./src/app/+admin/catalogos/region-sanitaria/region-sanitaria.module.ts",
		"app-admin-catalogos-region-sanitaria-region-sanitaria-module"
	],
	"app/+admin/catalogos/religiones/religiones.module": [
		"./src/app/+admin/catalogos/religiones/religiones.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"app-admin-catalogos-religiones-religiones-module"
	],
	"app/+admin/catalogos/unidades-medicas/unidades-medicas.module": [
		"./src/app/+admin/catalogos/unidades-medicas/unidades-medicas.module.ts",
		"app-admin-catalogos-unidades-medicas-unidades-medicas-module"
	],
	"app/+admin/catalogos/via-administracion/via-administracion.module": [
		"./src/app/+admin/catalogos/via-administracion/via-administracion.module.ts",
		"app-admin-catalogos-via-administracion-via-administracion-module"
	],
	"app/+admin/est-consultas/est-consultas.module": [
		"./src/app/+admin/est-consultas/est-consultas.module.ts",
		"default~app-admin-autorizacion-autorizacion-module~app-admin-est-consultas-est-consultas-module~app-~2a3300ba",
		"common",
		"app-admin-est-consultas-est-consultas-module"
	],
	"app/+admin/hist-clinic/hist-clinic.module": [
		"./src/app/+admin/hist-clinic/hist-clinic.module.ts",
		"default~app-admin-autorizacion-autorizacion-module~app-admin-est-consultas-est-consultas-module~app-~2a3300ba",
		"common",
		"app-admin-hist-clinic-hist-clinic-module"
	],
	"app/+admin/import/import.module": [
		"./src/app/+admin/import/import.module.ts",
		"common",
		"app-admin-import-import-module"
	],
	"app/+agenda/agenda.module": [
		"./src/app/+agenda/agenda.module.ts",
		"app-agenda-agenda-module"
	],
	"app/+canalizar/canalizar.module": [
		"./src/app/+canalizar/canalizar.module.ts",
		"default~app-canalizar-canalizar-module~app-consulta-lista-consulta-lista-module~app-paciente-detalle~12d50c0f",
		"common",
		"app-canalizar-canalizar-module"
	],
	"app/+consulta/+detalle/consulta.detalle.module": [
		"./src/app/+consulta/+detalle/consulta.detalle.module.ts",
		"app-consulta-detalle-consulta-detalle-module"
	],
	"app/+consulta/+detalle/documentos/consulta.detalle.documentos.lazymodule": [
		"./src/app/+consulta/+detalle/documentos/consulta.detalle.documentos.lazymodule.ts",
		"common",
		"app-consulta-detalle-documentos-consulta-detalle-documentos-lazymodule"
	],
	"app/+consulta/+detalle/estudios/consulta.detalle.estudios.lazymodule": [
		"./src/app/+consulta/+detalle/estudios/consulta.detalle.estudios.lazymodule.ts",
		"app-consulta-detalle-estudios-consulta-detalle-estudios-lazymodule"
	],
	"app/+consulta/+detalle/formatos/consulta.detalle.formatos.lazymodule": [
		"./src/app/+consulta/+detalle/formatos/consulta.detalle.formatos.lazymodule.ts",
		"app-consulta-detalle-formatos-consulta-detalle-formatos-lazymodule"
	],
	"app/+consulta/+detalle/imagenes/consulta.detalle.imagenes.lazymodule": [
		"./src/app/+consulta/+detalle/imagenes/consulta.detalle.imagenes.lazymodule.ts",
		"common",
		"app-consulta-detalle-imagenes-consulta-detalle-imagenes-lazymodule"
	],
	"app/+consulta/+detalle/recetas/consulta.detalle.recetas.lazymodule": [
		"./src/app/+consulta/+detalle/recetas/consulta.detalle.recetas.lazymodule.ts",
		"app-consulta-detalle-recetas-consulta-detalle-recetas-lazymodule"
	],
	"app/+consulta/+lista/consulta.lista.module": [
		"./src/app/+consulta/+lista/consulta.lista.module.ts",
		"default~app-canalizar-canalizar-module~app-consulta-lista-consulta-lista-module~app-paciente-detalle~12d50c0f",
		"common",
		"app-consulta-lista-consulta-lista-module"
	],
	"app/+consulta/consulta.module": [
		"./src/app/+consulta/consulta.module.ts",
		"app-consulta-consulta-module"
	],
	"app/+cuestionarios/cuestionarios.module": [
		"./src/app/+cuestionarios/cuestionarios.module.ts",
		"app-cuestionarios-cuestionarios-module"
	],
	"app/+dashboard/+general-dash/general-dashboard.module": [
		"./src/app/+dashboard/+general-dash/general-dashboard.module.ts",
		"default~app-dashboard-general-dash-general-dashboard-module~app-expediente-puebla-expediente-puebla-~27277d47",
		"common",
		"app-dashboard-general-dash-general-dashboard-module"
	],
	"app/+doctor/doctor.module": [
		"./src/app/+doctor/doctor.module.ts",
		"common",
		"app-doctor-doctor-module"
	],
	"app/+formato/+accion/formato.accion.module": [
		"./src/app/+formato/+accion/formato.accion.module.ts",
		"default~accion-formato-accion-module~app-admin-catalogos-catpreguntas-catpreguntas-module~app-admin-~fc33f66b",
		"default~accion-formato-accion-module~app-admin-catalogos-cie10-cie10-module~app-admin-catalogos-disc~54a3e788",
		"common",
		"accion-formato-accion-module"
	],
	"app/+formato/formato.module": [
		"./src/app/+formato/formato.module.ts",
		"app-formato-formato-module"
	],
	"app/+notificaciones/notificaciones.module": [
		"./src/app/+notificaciones/notificaciones.module.ts",
		"app-notificaciones-notificaciones-module"
	],
	"app/+paciente/+detalle/+cursos-clinicos/+paciente-historia-clinica/paciente.historia-clinica.module": [
		"./src/app/+paciente/+detalle/+cursos-clinicos/+paciente-historia-clinica/paciente.historia-clinica.module.ts",
		"app-paciente-detalle-cursos-clinicos-paciente-historia-clinica-paciente-historia-clinica-module"
	],
	"app/+paciente/+detalle/+cursos-clinicos/paciente.detalle.cursos-clinicos.module": [
		"./src/app/+paciente/+detalle/+cursos-clinicos/paciente.detalle.cursos-clinicos.module.ts",
		"default~app-canalizar-canalizar-module~app-consulta-lista-consulta-lista-module~app-paciente-detalle~12d50c0f",
		"common",
		"app-paciente-detalle-cursos-clinicos-paciente-detalle-cursos-clinicos-module"
	],
	"app/+paciente/+detalle/+perfil/paciente.detalle.perfil.module": [
		"./src/app/+paciente/+detalle/+perfil/paciente.detalle.perfil.module.ts",
		"common",
		"app-paciente-detalle-perfil-paciente-detalle-perfil-module"
	],
	"app/+paciente/+detalle/+quiz/quiz.module": [
		"./src/app/+paciente/+detalle/+quiz/quiz.module.ts",
		"app-paciente-detalle-quiz-quiz-module"
	],
	"app/+paciente/+detalle/+telemetria/paciente.detalle.telemetria.module": [
		"./src/app/+paciente/+detalle/+telemetria/paciente.detalle.telemetria.module.ts",
		"app-paciente-detalle-telemetria-paciente-detalle-telemetria-module"
	],
	"app/+paciente/+detalle/consulta-actual/consulta.actual.module": [
		"./src/app/+paciente/+detalle/consulta-actual/consulta.actual.module.ts",
		"app-paciente-detalle-consulta-actual-consulta-actual-module"
	],
	"app/+paciente/+detalle/paciente.detalle.module": [
		"./src/app/+paciente/+detalle/paciente.detalle.module.ts",
		"common",
		"app-paciente-detalle-paciente-detalle-module"
	],
	"app/+paciente/paciente.module": [
		"./src/app/+paciente/paciente.module.ts",
		"app-paciente-paciente-module"
	],
	"app/+turnosLaborales/turnos.module": [
		"./src/app/+turnosLaborales/turnos.module.ts",
		"default~app-admin-autorizacion-autorizacion-module~app-admin-est-consultas-est-consultas-module~app-~2a3300ba",
		"default~app-admin-users-actions-users-actions-module~app-turnosLaborales-turnos-module",
		"common",
		"app-turnosLaborales-turnos-module"
	],
	"app/expediente-puebla/expediente-puebla.module": [
		"./src/app/expediente-puebla/expediente-puebla.module.ts",
		"default~app-dashboard-general-dash-general-dashboard-module~app-expediente-puebla-expediente-puebla-~27277d47",
		"common",
		"app-expediente-puebla-expediente-puebla-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;